import { FC } from 'react';

export const BookACallSvg: FC = () => (
  <svg
    width="407"
    height="299"
    viewBox="0 0 407 299"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M234.661 47.5635L234.182 47.3691V47.3243L122.975 3.1171C113.518 -0.635345 103.254 6.3164 103.254 16.4824V191.846L235.199 244.305L366.607 296.556V116.842C366.607 106.691 360.412 97.5563 350.955 93.7889L234.646 47.5485L234.661 47.5635Z"
      fill="white"
      stroke="#C7C8DD"
      stroke-miterlimit="10"
    />
    <path d="M103.254 25.9004L366.607 130.61" stroke="#C7C8DD" stroke-miterlimit="10" />
    <path
      d="M245.023 139.703C272.628 151.459 316.882 181.409 323.882 278.818C323.908 279.184 323.934 279.549 323.959 279.914L145.402 208.945C147.428 182.158 160.797 161.048 165.599 155.869C172.803 148.086 181.735 141.462 192.1 137.397C195.77 135.957 199.599 134.838 203.617 134.092C215.12 131.972 228.003 132.945 241.997 138.463C242.063 138.49 242.13 138.516 242.198 138.543C242.536 138.677 242.882 138.814 243.229 138.97C243.818 139.196 244.421 139.449 245.023 139.703Z"
      fill="#C7C8DD"
    />
    <path
      d="M252.63 199.446L323.455 227.064C323.455 227.064 349.374 159.77 325.48 135.736C313.856 124.046 306.62 125.3 301.298 129.179C296.512 132.667 296.512 139.315 296.512 149.147C296.512 160.71 288.28 188.039 279.397 184.832C270.514 181.625 276.023 164.274 278.308 159.083C280.593 153.892 274.63 152.915 269.063 160.71C263.496 168.505 252.63 199.446 252.63 199.446Z"
      fill="white"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path d="M325.451 136.511C325.451 136.511 332.905 147.651 324.204 175.023Z" fill="white" />
    <path
      d="M325.451 136.511C325.035 136.789 325.035 136.789 325.035 136.789C325.035 136.789 325.034 136.789 325.034 136.789C325.034 136.788 325.034 136.788 325.034 136.789C325.035 136.789 325.036 136.79 325.037 136.792C325.039 136.796 325.043 136.802 325.049 136.811C325.06 136.829 325.078 136.858 325.102 136.899C325.15 136.979 325.221 137.104 325.311 137.275C325.489 137.616 325.738 138.141 326.012 138.858C326.561 140.293 327.211 142.502 327.594 145.565C328.36 151.69 328.059 161.244 323.728 174.871L324.204 175.023L324.681 175.174C329.05 161.429 329.373 151.728 328.586 145.44C328.193 142.297 327.524 140.01 326.947 138.501C326.658 137.746 326.393 137.187 326.197 136.812C326.1 136.625 326.019 136.484 325.962 136.388C325.934 136.34 325.911 136.303 325.895 136.277C325.887 136.264 325.88 136.254 325.875 136.247C325.873 136.243 325.871 136.24 325.87 136.238C325.869 136.237 325.868 136.236 325.868 136.235C325.867 136.235 325.867 136.234 325.867 136.234C325.867 136.234 325.866 136.233 325.451 136.511Z"
      fill="#252858"
    />
    <path d="M315.676 128.928C315.676 128.928 323.13 140.068 314.429 167.44Z" fill="white" />
    <path
      d="M315.676 128.928C315.26 129.206 315.26 129.206 315.259 129.206C315.259 129.206 315.259 129.206 315.259 129.206C315.259 129.205 315.259 129.205 315.259 129.206C315.26 129.206 315.26 129.207 315.262 129.209C315.264 129.213 315.268 129.219 315.274 129.228C315.285 129.246 315.303 129.275 315.327 129.316C315.375 129.396 315.446 129.521 315.535 129.692C315.714 130.033 315.963 130.558 316.237 131.275C316.786 132.71 317.436 134.919 317.819 137.982C318.585 144.107 318.284 153.661 313.952 167.288L314.429 167.44L314.906 167.591C319.275 153.846 319.598 144.145 318.811 137.857C318.418 134.714 317.749 132.427 317.171 130.918C316.883 130.163 316.618 129.604 316.422 129.229C316.324 129.042 316.244 128.901 316.187 128.805C316.159 128.757 316.136 128.72 316.12 128.694C316.111 128.681 316.105 128.671 316.1 128.664C316.098 128.66 316.096 128.657 316.094 128.655C316.094 128.654 316.093 128.653 316.092 128.652C316.092 128.652 316.092 128.651 316.092 128.651C316.091 128.651 316.091 128.65 315.676 128.928Z"
      fill="#252858"
    />
    <path d="M303.455 127.934C303.455 127.934 310.909 139.074 302.208 166.446Z" fill="white" />
    <path
      d="M303.455 127.934C303.039 128.212 303.039 128.212 303.039 128.212C303.039 128.212 303.038 128.211 303.038 128.211C303.038 128.211 303.038 128.211 303.039 128.212C303.039 128.212 303.04 128.213 303.041 128.215C303.043 128.219 303.047 128.225 303.053 128.234C303.064 128.252 303.082 128.281 303.106 128.321C303.154 128.402 303.225 128.527 303.315 128.698C303.493 129.039 303.742 129.564 304.016 130.281C304.565 131.716 305.215 133.925 305.598 136.988C306.364 143.112 306.063 152.667 301.732 166.294L302.208 166.446L302.685 166.597C307.054 152.852 307.377 143.151 306.591 136.863C306.197 133.72 305.528 131.433 304.951 129.924C304.662 129.169 304.397 128.61 304.201 128.235C304.104 128.048 304.023 127.907 303.966 127.81C303.938 127.762 303.915 127.726 303.899 127.7C303.891 127.687 303.884 127.677 303.879 127.67C303.877 127.666 303.875 127.663 303.874 127.661C303.873 127.66 303.872 127.659 303.872 127.658C303.871 127.658 303.871 127.657 303.871 127.657C303.871 127.656 303.87 127.656 303.455 127.934Z"
      fill="#252858"
    />
    <path
      d="M249.886 250.412L252.13 199.582L323.206 227.239C323.206 227.239 332.932 239.631 332.932 283.302C305.25 272.09 249.886 250.412 249.886 250.412Z"
      fill="#C7C8E0"
      stroke="#24275B"
    />
    <path
      d="M231.982 68.3708L240.69 151.082C242.195 165.295 233.964 174.563 222.511 171.798C210.855 168.977 200.39 155.244 198.888 141.015L190.181 58.3047L231.982 68.3708Z"
      fill="white"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M161.565 65.2491C155.206 57.49 154.263 47.7426 159.47 43.4819C164.678 39.2211 174.059 42.0467 180.419 49.8207C186.778 57.5797 187.721 67.3271 182.514 71.5879C177.306 75.8486 167.925 73.0231 161.565 65.2491Z"
      fill="white"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M155.879 84.6689C155.879 105.719 172.817 129.459 193.886 137.726C206.694 142.884 218.066 141.03 224.874 134.019L225.084 133.81L227.149 131.134L249.878 103.476L204.42 36.5897L170.737 31.2227L158.138 72.096C156.687 75.8185 155.864 79.9447 155.864 84.6839L155.879 84.6689Z"
      fill="white"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M233.359 87.5697C235.424 88.3919 248.038 103.043 250.103 103.671C254.023 98.7224 256.297 91.6959 256.297 83.4435C256.297 59.0899 236.456 31.4175 212.081 21.5206C192.24 13.6718 175.511 19.8611 169.93 35.5586C173.655 38.0403 177.576 40.3127 181.706 41.9572L233.359 87.5846V87.5697Z"
      fill="#252858"
    />
    <path
      d="M243.893 101.593C245.958 102.415 248.023 103.043 250.088 103.656C254.008 98.7077 256.282 91.6812 256.282 83.4288C256.282 59.0753 236.441 31.4028 212.066 21.5059C192.225 13.6572 175.496 19.8465 169.915 35.544C173.64 38.0257 177.561 40.2981 181.691 41.9426"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M176.124 92.5186C176.124 93.1315 175.915 93.7594 175.915 94.3724C175.915 102.625 182.529 111.924 190.788 115.228C199.048 118.532 205.662 114.6 205.662 106.347C205.662 103.253 204.629 99.9487 203.178 97.0634L176.109 92.5186H176.124Z"
      fill="white"
    />
    <path
      d="M173.429 94.7734L173.912 94.6441C174.004 94.9876 174.036 95.3434 174.065 95.6487C174.096 95.9698 174.123 96.2404 174.189 96.4889L173.706 96.6182L173.223 96.7475C173.131 96.404 173.099 96.0482 173.07 95.7429C173.039 95.4218 173.012 95.1513 172.946 94.9027L173.429 94.7734ZM173.706 96.6182L174.189 96.4889C175.225 100.351 177.887 104.079 181.398 106.975C184.907 109.871 189.228 111.906 193.535 112.42L193.476 112.917L193.416 113.413C188.889 112.872 184.394 110.743 180.762 107.746C177.131 104.751 174.325 100.856 173.223 96.7475L173.706 96.6182Z"
      fill="#252858"
    />
    <path
      d="M233.359 117.305C241.618 120.609 248.232 116.677 248.232 108.425C248.232 100.172 241.618 90.8733 233.359 87.5693V117.305Z"
      fill="white"
    />
    <path
      d="M233.359 117.305C241.618 120.609 248.232 116.677 248.232 108.425C248.232 100.172 241.618 90.8733 233.359 87.5693"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M180.778 59.6883C173.955 52.4674 164.663 50.5987 160.114 55.5621"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path d="M186.045 89.0196L174.269 78.6891L189.142 66.3105L186.045 89.0196Z" fill="white" />
    <path
      d="M186.045 89.0199L179.701 83.4585C176.843 80.9469 176.902 76.4918 179.82 74.055L189.142 66.2959"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M218.62 78.9584L165.994 34.3027V30.3858C165.994 11.3993 181.287 2.30974 200.29 9.94919C219.293 17.5886 234.586 39.0568 234.586 58.0433C234.376 69.196 226.88 76.0581 218.62 78.9434V78.9584Z"
      fill="#252858"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M178.803 50.1202C178.803 31.1337 194.095 22.0441 213.099 29.6836"
      stroke="white"
      stroke-miterlimit="10"
    />
    <path
      d="M190.309 58.3124C183.337 47.4886 193.512 34.7662 203.178 34.6914"
      stroke="white"
      stroke-miterlimit="10"
    />
    <path
      d="M214.46 92.0994C214.46 83.847 207.846 74.5481 199.587 71.2441"
      stroke="#252858"
      stroke-miterlimit="10"
    />
    <path
      d="M177.275 205.396C171.708 199.182 170.58 191.118 174.755 187.385C178.93 183.651 186.827 185.662 192.394 191.876C197.96 198.09 199.088 206.154 194.914 209.887C190.739 213.62 182.842 211.61 177.275 205.396Z"
      fill="#F7F8FC"
    />
    <path
      d="M207.133 216.594C201.566 210.38 200.438 202.317 204.613 198.583C208.788 194.85 216.685 196.86 222.252 203.074C227.818 209.288 228.946 217.352 224.771 221.085C220.596 224.819 212.699 222.808 207.133 216.594Z"
      fill="#F7F8FC"
    />
    <path
      d="M236.991 227.792C231.424 221.579 230.296 213.515 234.471 209.781C238.646 206.048 246.543 208.059 252.109 214.272C257.676 220.486 258.804 228.55 254.629 232.283C250.454 236.017 242.557 234.006 236.991 227.792Z"
      fill="#F7F8FC"
    />
    <path
      d="M317.126 102.486C314.547 99.6064 314.023 95.8706 315.957 94.1415C317.89 92.4125 321.548 93.3449 324.128 96.2241C326.707 99.1034 327.231 102.839 325.297 104.568C323.364 106.297 319.705 105.365 317.126 102.486Z"
      fill="#C7C8DD"
    />
    <path
      d="M330.972 107.683C328.393 104.804 327.869 101.068 329.803 99.3388C331.736 97.6097 335.394 98.5422 337.974 101.421C340.553 104.301 341.077 108.036 339.143 109.766C337.21 111.495 333.551 110.562 330.972 107.683Z"
      fill="#C7C8DD"
    />
    <path
      d="M344.793 112.855C342.214 109.975 341.69 106.24 343.624 104.511C345.557 102.782 349.216 103.714 351.795 106.593C354.374 109.473 354.898 113.208 352.965 114.937C351.031 116.666 347.373 115.734 344.793 112.855Z"
      fill="#C7C8DD"
    />
    <path
      d="M53.0021 231.748C33.63 214.425 35.5784 180.676 57.354 156.368C79.1297 132.061 112.487 126.399 131.859 143.723C151.231 161.046 149.282 194.795 127.507 219.103C105.731 243.41 72.3742 249.072 53.0021 231.748Z"
      fill="#27245C"
    />
    <path
      d="M72.2795 209.875L105.378 198.438L104.825 173.711L71.7258 185.133L72.2795 209.875Z"
      fill="white"
    />
    <path d="M105.094 186.075L120.596 193.191L120.042 168.449L105.094 186.075Z" fill="white" />
    <path
      d="M201.368 82.2771C200.141 80.7821 199.976 78.8835 200.993 78.0463C202.011 77.2091 203.851 77.7473 205.078 79.2423C206.305 80.7373 206.47 82.6359 205.453 83.4731C204.435 84.3103 202.595 83.7721 201.368 82.2771Z"
      fill="#252858"
    />
    <path
      d="M172.474 63.6052C171.247 62.1102 171.082 60.2116 172.099 59.3744C173.117 58.5372 174.957 59.0754 176.184 60.5704C177.411 62.0654 177.576 63.964 176.558 64.8012C175.541 65.6384 173.701 65.1002 172.474 63.6052Z"
      fill="#252858"
    />
  </svg>
);
